/*
 * @Author: 'Lizz' lzz1961690348@163.com
 * @Date: 2023-05-05 14:22:10
 * @LastEditors: The_xu 2596841393@qq.com
 * @LastEditTime: 2025-11-01 18:52:24
 * @FilePath: \yda-qywx-h5\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import { Toast } from 'vant'
import 'vant/es/toast/style'
import router from '../router'
import { APP, environmentJudge, checkMobile, YKY } from '@/utils/utils.js'
import service, { setSessionId, setHeader } from '@hybird/core/request'
import { Device, } from '@hybird/device'
import { switchApp } from "@hybird/device/request";
import { userLogout } from "@/utils/env";
import { defaultError, WebError } from "@hybird/core/error";

// 创建 axios 实例
const request = axios.create({
  // TODO 后续完成后记得改过来
  baseURL: process.env.VITE_API_BASE_URL,
  // baseURL: 'https://uatapi.libawall.com',
  timeout: 60 * 60 * 1000,
  // withCredentials: true // 允许携带cookie
})

// 允许跨域携带cookie
// request.defaults.withCredentials = true
service.defaults.baseURL = process.env.VITE_API_BASE_URL
service.debug = true
// 异常处理
const errorRequest = (err) => {
  console.log('请求异常', err)
  return Promise.reject(err)
}
// setHeader("sourceType", getSourceType())
// switchApp(2)

// 请求拦截器
request.interceptors.request.use((config) => {
  const types = ['post', 'put', 'delete']
  const { params = {}, method, data } = config
  if (
    localStorage.getItem('sessionId') != null &&
    localStorage.getItem('sessionId') != ''
  ) {
    config.headers.sessionId = localStorage.getItem('sessionId')
    setSessionId(localStorage.getItem('sessionId'))
  }
  if (types.includes(method.toLowerCase()) && !config.noFormData) {
    if (!data) config.data = objToFormData(params)
    delete config.params
  }
  // 判断是否是app环境
  config.headers['sourceType'] = getSourceType()
  config.headers["endpointVersion"] = `v${process.env.VUE_APP_API_VERSION}`;
  console.log('请求参数打印=', [APP, YKY].includes(environmentJudge()) ? JSON.stringify(config) : config);
  return config
}, errorRequest)

function objToFormData(obj) {
  const form = new FormData()
  Object.keys(obj).forEach((item) => {
    obj[item] !== undefined && obj[item] !== null && form.set(item, obj[item])
  })
  return form
}

// 响应拦截器
request.interceptors.response.use(async (response) => {
  console.log('请求结果打印=', [APP, YKY].includes(environmentJudge()) ? JSON.stringify(response) : response);

  const { code, message } = response.data
  // 当code返回失败时 抛出错误
  if (code != 0) {
    if (code == 9022 || code == 9027) {      
      
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      // 盖印码登录 用户禁用之后跳转到盖印码页面
      if(userInfo.loginType == 18){
        Toast(message)
        return  !location.href.endsWith('/stampCode') ? router.push('/stampCode') : null
      } 

      if (!location.href.endsWith('/me')) {
        router.push(`/me`)
      }
    }
    if (
      response.config.url === '/wechat/manage/submit' ||
      response.config.url === '/wechat/manage/reApply' ||
      response.config.url === '/wechat/workspace/process/detail' ||
      response.config.url.includes('wechat/manage/reApply/check') ||
      response.config.url === '/wechat/workspace/process/info' ||
      response.config.url === '/wechat/item/receiving/record'
    ) {
      const list = [8002, 8003, 8004, 8006, 8010, 8019, 8022]
      if (list.findIndex((item) => item === code) > -1) {
        return response.data
      }
    }
    if (
      response.config.url.includes('wechat/home/seal/details') &&
      code === 1080
    )
      return response.data

    //重新解析&图片矫正无需抛错
    if (
      response.config.url.includes('wechat/ocr/ocrAnalysis') ||
      response.config.url.includes('wechat/manage/imageCorrection')
    )
      return response.data

    if (code === 1082) return response.data
    if (code === 2107) return response.data
    if (code === 2112) return response.data
    if (code === 2109) return response.data
    if (code === 9026) return response.data
    // 查询归档流程是否有变更
    if (
      code === 8023 &&
      (response.config.url === 'wechat/manage/archive/reApply' ||
        response.config.url === '/wechat/manage/archive/submit')
    )
      return response.data

    //文件下载流返回
    if(response.config.isStream){
      return response
    }

    if (response.config?.show != false) {
      Toast(message)
    }
    // 未登录
    if (code == 601) {
      await userLogoutPage();
    }
  }
  return response.data
}, errorRequest)

const userLogoutPage = async () => {
  await userLogout();
  const enterpriseId =
    getLocation('enterpriseId') || localStorage.getItem('enterpriseId')

  const environment = environmentJudge()
  console.log('request enterpriseId', enterpriseId)
  console.log(environment == APP, environment == 'OTHERS')
  if (environment == APP || environment == 'OTHERS' || environment == YKY) {
    router.push(`/loginAccount`)
  } else {
    router.push(`/login?enterpriseId=${enterpriseId}`)
  }
}

//获取地址栏
const getLocation = (name) => {
  // 未传参，返回空
  if (!name) return null
  // 查询参数：先通过search取值，如果取不到就通过hash来取
  var after = window.location.search
  after = after.substr(1) || window.location.hash.split('?')[1]
  // 地址栏URL没有查询参数，返回空
  if (!after) return null
  // 如果查询参数中没有"name"，返回空
  if (after.indexOf(name) === -1) return null

  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  // 当地址栏参数存在中文时，需要解码，不然会乱码
  var r = decodeURI(after).match(reg)
  // 如果url中"name"没有值，返回空
  if (!r) return null

  return r[2]
}

service.interceptors.response.use(async (response) => {
  return response
}, async (err) => {
  console.log('请求异常1', err)
  if (defaultError.isError(err, defaultError.REQUEST_ERROR) && err.data.code == 601) {
    Toast(err.data.message)
    await userLogoutPage();
  }
  return Promise.reject(err)
})

export function getSourceType() {
  switch (environmentJudge()) {
    case APP:
      return 2
    case YKY:
      return 3
    default:
      return 1
  }
}
export default request
